import React, { useEffect } from "react";
import { connect } from "react-redux";
import {
  createLotGoal,
  deleteLotGoal,
  fetchLotGoals,
  reactivateLotGoal,
  updateLotGoal,
} from "redux/operations";
import type { RootState } from "redux/reducers";
import LotGoalPage from "./lotGoalPage";

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

type LotGoalContainerProps = StateProps & DispatchProps;

function LotGoalContainer({
  activateLotGoalDispatch,
  createLotGoalDispatch,
  deleteLotGoalDispatch,
  fetchLotGoalsDispatch,
  goals,
  updateLotGoalDispatch,
}: LotGoalContainerProps) {
  useEffect(() => {
    fetchLotGoalsDispatch();

    // We want to run this only once on component mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleActivateGoal = async (
    ...params: Parameters<typeof activateLotGoalDispatch>
  ) => {
    await Promise.resolve(activateLotGoalDispatch(...params));
    // Ensure cause of death is activated before refetching
    fetchLotGoalsDispatch();
  };

  const handleCreateGoal = async (
    ...params: Parameters<typeof createLotGoalDispatch>
  ) => {
    await Promise.resolve(createLotGoalDispatch(...params));
    // Ensure cause of death is created before refetching
    fetchLotGoalsDispatch();
  };
  const handleUpdateGoal = async (
    ...params: Parameters<typeof updateLotGoalDispatch>
  ) => {
    await Promise.resolve(updateLotGoalDispatch(...params));
    // Ensure cause of death is updated before refetching
    fetchLotGoalsDispatch();
  };

  const handleDeleteGoal = async (
    ...params: Parameters<typeof deleteLotGoalDispatch>
  ) => {
    await Promise.resolve(deleteLotGoalDispatch(...params));
    // Ensure cause of death is deleted before refetching
    fetchLotGoalsDispatch();
  };

  return (
    <LotGoalPage
      activateGoal={handleActivateGoal}
      goals={goals}
      createGoal={handleCreateGoal}
      deleteGoal={handleDeleteGoal}
      updateGoal={handleUpdateGoal}
    />
  );
}

const mapStateToProps = (state: RootState) => ({
  goals: state.lot.goals,
});

const mapDispatchToProps = {
  activateLotGoalDispatch: reactivateLotGoal,
  createLotGoalDispatch: createLotGoal,
  deleteLotGoalDispatch: deleteLotGoal,
  fetchLotGoalsDispatch: fetchLotGoals,
  updateLotGoalDispatch: updateLotGoal,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
export default connector(LotGoalContainer);
